// import { Box, Card, Grid, Typography } from "@mui/material";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import { useMaterialUIController } from "context";

// /* eslint-disable react-hooks/exhaustive-deps */
import { Box, Card, Grid, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import "cropperjs/dist/cropper.css";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import "react-toastify/dist/ReactToastify.css";

const headingStyle = {
  fontSize: "24px",
  fontWeight: 700,
  color: "#000",
  lineHeight: "26px",
  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
};

const titleStyle = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000",
  lineHeight: "26px",
  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
};

const contentStyle = {
  fontSize: "14px",
  fontWeight: 500,
  color: "rgba(0, 0, 0, 0.87)",
  lineHeight: "20px",
  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
  whiteSpace: "pre-line", // ✅ ADD THIS HERE
};

const descStyle = {
  fontSize: "14px",
  fontWeight: 500,
  color: "rgba(0, 0, 0, 0.87)",
  lineHeight: "20px",
  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
  whiteSpace: "pre-line", // ✅ ADD THIS HERE
  marginTop: "4px",
};

// ✅ COMMON IMAGE STYLE (NO ZOOM)
const imgStyle = {
  display: "block",
  maxWidth: "100%",
  width: "auto",
  height: "auto",
  maxHeight: "420px",
  objectFit: "contain",
  borderRadius: "10px",
};

/* ✅ COMMON CENTER IMAGE COMPONENT */
const ImageBox = ({ src }) => (
  <Box mt={2} display="flex" justifyContent="center" width="100%">
    <img src={src} alt="" style={imgStyle} />
  </Box>
);

function HelpScreen() {
  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;

  // ✅ Dynamic text color
  const textColor = darkMode ? "#fff" : "rgba(0,0,0,0.87)";
  const headingColor = darkMode ? "#fff" : "#000";

  const helpData = [
    {
      title: "Registration",
      steps: [
        {
          title: "Sign Up",
          content:
            "Enter first name, last name, email address, and phone number, or sign up using Google/Facebook.",
          image: "/help/image1.png",
        },
        {
          title: "Email Verification",
          content:
            "An OTP is sent to your registered email. Enter the OTP to verify your account.",
          image: "/help/image2.png",
        },
        {
          title: "Set Password",
          content: "Create a secure password to complete your account setup.",
          image: "/help/image3.png",
        },
        {
          title: "Business Details",
          content:
            "Provide your business name, ABN number, organization type, industry type, upload logo, and address.\nTick the checkbox to accept the Terms & Conditions and Privacy Policy.",
          image: "/help/image4.png",
        },
        {
          title: "Registration Complete",
          content:
            "Once submitted, registration is complete and you are enrolled in the Silver Plan.",
        },
      ],
    },
    {
      title: "Quotation",
      steps: [
        {
          title: "Add New Quotation",
          content: "Click on the Add New button to create a new quotation.",
          image: "/help/image5.png",
        },
        {
          title: "Customer Selection",
          content:
            "From the Customer field, select an existing customer from the drop-down list,or click Add New Customer to create a new one.\nYou can also create customers directly from the Contacts section.",
          image: "/help/image6.png",
        },
        {
          title: "Quotation Details",
          content:
            "The Quotation Date is auto-entered.\nSet the Due Date by selecting from available options — Same Day, 7 Days, 14 Days, 30 Days,14 Days, End of Month, or 30 Days End of Month — or choose a custom date from the calendar.",
        },
        {
          title: "Quotation & Reference Numbers",
          content:
            "A unique Quotation Number is auto-generated.\nEnter the Reference Number as needed.",
        },
        {
          title: "Item Details",
          content:
            "Add items to the quotation by selecting them from the drop-down list.\nTo create a new item, click Add New Item; once created, it will appear in the drop-down for future use.\nAll calculations (such as item totals, taxes, and grand totals) are performedautomatically.\nUpload any related documents to attach to the quotation.",
        },
        {
          title: "Save & Send",
          content:
            "After entering all details, you can save the quotation or send it via email directly from thesystem.",
          image: "/help/image7.png",
        },
        {
          title: "Available Actions",
          content:
            "After saving, you can edit, view history, delete, send email, clone, preview/download, or create an invoice from the quotation.",
          image: "/help/image8.png",
        },
        {
          title: "Quotation Approval",
          content:
            "When a quotation is approved by the customer, you can proceed to create an invoice for that particular quotation.",
        },
      ],
    },
    {
      title: "Invoice",
      steps: [
        {
          title: "Add New Invoice",
          content: "Click on the Add New button to create a new invoice.",
          image: "/help/image9.png",
        },
        {
          title: "Customer Selection",
          content:
            "From the Customer field, select an existing customer from the drop-down list, or click Add New Customer to create a new one.\nYou can also create customers directly from the Contacts section.",
          image: "/help/image10.png",
        },
        {
          title: "Invoice Details",
          content:
            "The Invoice Date is auto-entered.\nSet the Due Date by selecting from available options — Same Day, 7 Days, 14 Days, 30 Days, 14 Days End of Month, or 30 Days End of Month — or choose a custom date from the calendar.",
        },
        {
          title: "Invoice & Reference Numbers",
          content:
            "A unique Invoice Number is auto-generated.\nEnter the Reference Number as needed.",
        },
        {
          title: "Item Details, Attachments & Send",
          content:
            "Add items to the invoice by selecting them from the drop-down list.\nTo create a new item, click Add New Item; once created, it will appear in the drop-down for future use.\nAll calculations (such as item totals, taxes, and grand totals) are performed automatically.\nYou can also upload supporting documents and choose to save the invoice or send it via email directly.",
        },
        {
          title: "Retention & Partial Payment",
          blocks: [
            {
              type: "text",
              value:
                "The invoice includes options for Retention and Partial Payment.",
            },
            {
              type: "image",
              value: "/help/image11.png",
            },
            {
              type: "text",
              value:
                "Retention allows a portion of the payment to be held until project completion.",
            },
            {
              type: "image",
              value: "/help/image12.png",
            },
            {
              type: "text",
              value:
                "Partial Payment enables customers to pay the invoice amount in multiple installments.",
            },
          ],
        },
        {
          title: "Available Actions",
          content:
            "After saving, you can edit, view history, delete, send email, clone, and preview/downloadthe invoice.",
          image: "/help/image13.png",
        },
      ],
    },
    {
      title: "Expenses",
      steps: [
        {
          title: "Add New Expense",
          content: "Click on the Add New button to create a new expense.",
          image: "/help/image14.png",
        },
        {
          title: "Expense Details",
          content:
            "Enter the required details — expense date (auto-filled), supplier name (select from the drop-down or add new), account, total amount ($), tax amount ($), upload document, and notes (optional).",
          image: "/help/image15.png",
        },
        {
          title: "Save Expense",
          content:
            "After entering all details, click Save to record the expense in the system.",
        },
      ],
    },
    {
      title: "Debt Collection",
      steps: [
        {
          content:
            "The Debt Collection module helps manage outstanding invoices and track payment follow-ups.",
          image: "/help/image16.png",
        },

        {
          title: "a) Debts",
          content:
            "The Debt Collection module helps manage overdue invoices and track pending payments.",
          image: "/help/image17.png",
          list: [
            {
              title: "Debt Screen",
              desc: "All overdue invoices are displayed in the Debt screen for easy monitoring and follow-up.",
            },
            {
              title: "Available Actions",
              desc: "From the Actions menu, you can edit (to record a payment), view, send an email, or download debts for reference.",
              image: "/help/image18.png",
            },
            {
              title: "Invoice Payment",
              desc: "If we pay the invoice from the Debt screen, the invoice is then displayed in the Invoices screen.",
            },
            {
              title: "Invoice Reminder Logs",
              desc: "The Invoice Reminder Logs section records all reminders sent to customers for outstanding invoices.",
            },
          ],
        },
        {
          title: "b) Invoice Reminder Logs:",
          content:
            "The Invoice Reminder Logs screen displays all created and scheduled invoice reminders,with an option to export the reminder list.",
          image: "/help/image19.png",
          list: [
            {
              title: "Reminder Template Setup",
              desc: "Reminder templates are created from the Invoice Reminder Templates option under Settings.",
              image: "/help/image20.png",
            },
            {
              title: "Add New Template",
              desc: "Click Add New to create a reminder template and enter the following details: template name, reminder type (due in or overdue), due in days, legal document, status(active/inactive), email subject, and email body.",
              image: "/help/image21.png",
            },
            {
              title: "Save or Cancel",
              desc: "After entering all details, choose to Save the template or Cancel to discard changes.",
            },
            {
              title: "Automatic Reminders",
              desc: "Based on the set templates, reminder emails are automatically sent to users for due-in or overdue invoices.",
            },
          ],
        },
      ],
    },
    {
      title: "Contacts",
      steps: [
        {
          title: "Add New Contact",
          content: "Click on the Add New button to create a new contact.",
          image: "/help/image22.png",
        },
        {
          title: "Contact Details",
          content:
            "Enter the required details — contact type (customer or supplier), company name, contact status, primary person details (full name, mobile number, email address, ABN number),invoice reminder, payment terms, address details (or enter manually), upload logo, and other email address if needed.\nAfter entering all details, choose to Save the contact or Cancel to discard changes.",
          image: ["/help/image23.png", "/help/image24.png"],
        },
      ],
    },
    {
      title: "Settings",
      steps: [
        {
          content:
            "The Settings section allows users to manage system configurations and preferences for their accounts.",
          image: "/help/image25.png",
        },
        {
          title: "Available Options",
          content:
            "Under Settings, users can manage users, items, user roles, subscriptions, default settings, invoice themes, and invoice reminder templates.",
        },
        {
          title: "a) Users:",
          list: [
            {
              title: "Add New User",
              desc: "Click on the Add New button to create a new user.",
              image: "/help/image26.png",
            },
            {
              title: "User Details",
              desc: "Enter the first name, last name, and select the role.\nRoles are created under User Roles in Settings or can be selected from existing roles.\nTo create a new role, click Add New, enter the role name, role description, and assign access levels — None, Full Access, or View Only for different screens.\nAfter creating the role, it will appear in the Role dropdown in the Users screen.",
              image: "/help/image27.png",
            },
            {
              title: "Additional Details",
              desc: "Enter the email address and select the status (Active or Inactive) for the user.",
            },
          ],
        },
        {
          title: "b) Items:",

          list: [
            {
              title: "Add New Item",
              desc: "Click on the Add New button to create a new item.",
              image: "/help/image28.png",
            },
            {
              title: "Item Details",
              desc: "Enter the following details — item code, item name, account, description, status (Active or Inactive), unit of measurement (optional), unit price ($), default quantity, GST (%), discount type (None, Percentage, or Fixed), and discount value.",
              image: "/help/image29.png",
            },
          ],
        },
        {
          title: "c) User roles:",
          content:
            "The User Roles screen allows the creation and management of roles, including assigning access levels (None, Full Access, or View Only) for different screens.\nNote: The role creation process is already detailed in the Users section.",
          image: "/help/image30.png",
        },
        {
          title: "d) Subscriptions:",
          content:
            "New users are registered with the Silver Plan. Users can upgrade their plan or manage their subscription from the Subscriptions screen.",
          image: "/help/image31.png",
          list: [
            {
              title: "Subscription Details",
              desc: "The following fields are displayed on the Subscriptions screen: Subscription Plan (Active), Activation Date, Billing Cycle End Date, and New Billing Date.",
            },

            {
              title: "Available Actions",
              desc: "Five buttons are available for managing subscriptions:",
              image: "/help/image32.png",
              items: [
                {
                  title: "Add Payment Method",
                  desc: "Enter cardholder name, card number, expiry month, expiry year, and CVV, then choose to Add or Cancel.",
                  image: "/help/image33.png",
                },
                {
                  title: "a)",
                },
                {
                  title: " b) View Plans",
                  image: "/help/image34.png",
                },
                {
                  title: "Change Plan",
                  desc: "Update your plan by entering subscription plan, activation date, billing cycle end date, new billing date, new subscription plan, and plan monthly cost ($).Users can also click View Plans to see available plans.",
                },
                {
                  title: "Add Credit",
                  desc: "Add credits to your account with an option to Proceed or Cancel.",
                  image: "/help/image35.png",
                },
                {
                  title: "View Credit Use",
                  desc: "View credit details, including credit balance, credit used,transaction description, credits purchased, and transaction date &amp; time.",
                  image: "/help/image36.png",
                },
                {
                  title: "Cancel Subscription",
                  desc: "Cancel the current subscription plan.",
                  image: "/help/image37.png",
                },
              ],
            },
          ],
        },
        {
          title: "e) Default Settings:",
          content:
            "The Default Settings section allows users to configure system defaults for quotations, invoices, RCTIs, and company branding.",
          list: [
            {
              heading: "Settings Fields",
              desc: "Configure quotation, invoice, RCTI prefixes and start numbers, currency, signature, and business logo, then click Save to apply all changes.",
              image: "/help/image38.png",
            },
          ],
        },
        {
          title: "f) Invoice Themes:",
          content:
            "The Invoice Themes section allows users to customize the invoice PDF template according to their branding and layout preferences.",
          image: "/help/image39.png",
          list: [
            {
              heading: "Add New Theme",
              desc: "Click Add New to create a theme and configure theme name, font style &amp; size, default theme (yes/no), logo alignment, business name & address, checkbox options (show tax number, column headings, item code, unit price &amp; quantity, tax column, registered address, logo, hide discount), and standard terms & conditions, then click Save to apply the theme..",
              image: "/help/image40.png",
            },
          ],
        },
        {
          title: "g) Invoice Reminder Templates:",
          content:
            "The Invoice Reminder Templates screen allows users to create and manage templates for automated invoice reminders.\nNote: The template creation and setup process is already detailed in the Invoice Reminder Logs section.",
          image: "/help/image41.png",
        },
      ],
    },
    {
      title: "My Reports",
      steps: [
        {
          content:
            "The My Reports section provides access to all system reports for analysis and record-keeping.",
          image: "/help/image42.png",
        },
        {
          title: "Available Reports",
          content:
            "Users can view the following reports: Contact Reports, Expense Reports, Invoice Reports, RCTI Reports, Quotation Reports, Items Reports, Aged Payables Summary, and Aged Receivables Summary.",
        },
        {
          title: "Export Option",
          content:
            "All reports include an Export option to download the report data.",
        },
      ],
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3} mb={3}>
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Card sx={{ minHeight: "86vh", boxShadow: "none" }}>
              {/* HEADER */}
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Help
                </MDTypography>
              </MDBox>

              {/* CONTENT */}
              <Box sx={{ height: "80vh", overflowY: "auto", p: 3 }}>
                {helpData.map((section, index) => {
                  const isSettings = section.title?.trim() === "Settings";
                  const isDebt = section.title?.trim() === "Debt Collection";
                  return (
                    <Box key={index} mb={6}>
                      {/* SECTION TITLE */}
                      <Typography
                        sx={{ ...headingStyle, color: headingColor }}
                        align="center"
                      >
                        {section.title}
                      </Typography>

                      {/* STEPS */}
                      {section.steps?.map((step, i) => (
                        <Box mt={4} key={i}>
                          {/* STEP TITLE */}
                          {step.title && (
                            <Typography
                              sx={{ ...titleStyle, color: headingColor }}
                            >
                              {isSettings || isDebt
                                ? step.title
                                : `${i + 1}. ${step.title}`}
                            </Typography>
                          )}

                          {/* IMAGE */}
                          {step.image &&
                            (Array.isArray(step.image) ? (
                              <Box
                                mt={2}
                                display="flex"
                                flexDirection="column"
                                gap={2}
                                alignItems="center"
                              >
                                {step.image.map((img, idx) => (
                                  <img
                                    key={idx}
                                    src={img}
                                    alt=""
                                    style={imgStyle}
                                  />
                                ))}
                              </Box>
                            ) : (
                              <Box
                                mt={2}
                                display="flex"
                                justifyContent="center"
                              >
                                <img src={step.image} alt="" style={imgStyle} />
                              </Box>
                            ))}

                          {/* CONTENT */}
                          {step.content && (
                            <Typography
                              mt={2}
                              sx={{ ...contentStyle, color: textColor }}
                            >
                              {step.content}
                            </Typography>
                          )}

                          {/* LIST */}
                          {step.list?.length > 0 && (
                            <Box mt={2}>
                              {step.list.map((item, idx) => {
                                const hasAlphabet = /^[a-z]\)/i.test(
                                  item.desc || ""
                                );
                                return (
                                  <Box
                                    key={idx}
                                    mb={2}
                                    display="flex"
                                    gap="8px"
                                  >
                                    {!item.heading &&
                                      !hasAlphabet &&
                                      !isSettings && (
                                        <span
                                          style={{
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            minWidth: "25px",
                                          }}
                                        >
                                          {idx + 1}.
                                        </span>
                                      )}

                                    <Box width="100%">
                                      {(item.heading || item.title) && (
                                        <Typography
                                          sx={{
                                            ...titleStyle,
                                            color: textColor,
                                          }}
                                        >
                                          {item.heading || item.title}
                                        </Typography>
                                      )}

                                      {item.desc && (
                                        <Typography
                                          sx={{
                                            ...descStyle,
                                            color: textColor,
                                          }}
                                        >
                                          {item.desc}
                                        </Typography>
                                      )}

                                      {/* IMAGE INSIDE LIST */}
                                      {item.image && (
                                        <Box
                                          mt={1}
                                          display="flex"
                                          justifyContent="center"
                                        >
                                          <img
                                            src={item.image}
                                            alt=""
                                            style={{
                                              ...imgStyle,
                                              maxHeight: "350px",
                                            }}
                                          />
                                        </Box>
                                      )}
                                    </Box>
                                  </Box>
                                );
                              })}
                            </Box>
                          )}

                          {/* ✅ BLOCKS (FIXED POSITION) */}
                          {step.blocks?.map((block, idx) => (
                            <Box mt={2} key={idx} textAlign="center">
                              {block.type === "text" && (
                                <Typography
                                  textAlign="left"
                                  sx={{ ...contentStyle, color: textColor }}
                                >
                                  {block.value}
                                </Typography>
                              )}

                              {block.type === "image" && (
                                <ImageBox src={block.value} />
                              )}
                            </Box>
                          ))}
                        </Box>
                      ))}
                    </Box>
                  );
                })}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}
export default HelpScreen;
